<template>
  <ol class="step-indicator">
      <li v-for="step in steps" is="step-navigation-step" :key="step.id" :step="step" :currentStep="currentStep"></li>
  </ol>
</template>

<script>
  import Step from './Step'
  export default {
    name: "step-navigation",
    components: {
      'step-navigation-step': Step
    },
    props: {
      steps: Array,
      currentStep: Number
    }
  }
</script>